import styled from 'styled-components';
import { StyledButton } from '../../globalStyled';

export const StyledFormContainer = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.card};
  border: 1px solid ${({ theme }) => theme.border};
  max-width: 500px;
  padding: 60px;
  border-radius: ${({ theme }) => theme.cardRadius};
  @media only screen and (max-width: 768px) {
    padding: 45px;
    height: 440px;
    margin: 0 20px;
  }
`;

export const StyledFormHeader = styled.h2`
  font-family: 'Archivo', sans-serif;
  font-style: normal;
  line-height: 48px;
  letter-spacing: 0.02em;
  color: ${({ theme }) => theme.text};
  font-size: 30px;
  font-weight: 900;
  margin-bottom: 0px;
  text-transform: none;
  text-align: center;
`;

export const StyledFormParagraph = styled.p`
  font-family: Archivo;
  font-size: 15px;
  line-height: 18px;
  font-weight: normal;
  color: ${({ theme }) => theme.text};
  margin-top: 20px;
  @media only screen and (max-width: 768px) {
    font-size: 14px;
  }
`;

export const StyledBidContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 20px;
  padding-bottom: 20px;
`;

export const StyledFormButton = styled(StyledButton)`
  width: 100%;
  max-width: 210px;
  height: 45px;
  font-size: 16px;
  margin: 30px auto 25px auto;
  &:disabled {
    background-color: ${({ theme }) => theme.hover};
    color: ${({ theme }) => theme.textFaint};
    border: 1px solid ${({ theme }) => theme.border};
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.06);
  }
`;

export const StyledNumberScout = styled.p`
  font-size: 13px;
  text-align: center;
  color: ${({ theme }) => theme.text};
  span {
    font-weight: bold;
    font-size: 16px;
  }
`;
